import { Card, CardBody, Tab, Tabs } from "@nextui-org/react";
import Order from "./Order";
import Orders from "./Orders";
import { useState } from "react";
import {  useSearchParams } from "react-router-dom";

const OrdersTab = () => {
    const [searchParams] = useSearchParams();
    const OrderId = searchParams.get('order');

    const [onOrder, setOnOrder] = useState(OrderId ? { id: OrderId } : undefined)

    return (
        <>
            <div className="flex flex-col gap-4">
                {!!onOrder ? <Order setOnOrder={setOnOrder} />
                    : <Tabs aria-label="Options" className="border-b pb-3 px-1">
                        <Tab key="1" title="در انتظار پرداخت">
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <Orders setOnOrder={setOnOrder} status='1' />
                                </CardBody>
                            </Card>
                        </Tab>
                        <Tab key="2" title="در حال اماده سازی" >
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <Orders setOnOrder={setOnOrder} status='2' />
                                </CardBody>
                            </Card>
                        </Tab>
                        <Tab key="3" title="ارسال شده" >
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <Orders setOnOrder={setOnOrder} status='3' />
                                </CardBody>
                            </Card>
                        </Tab>
                        <Tab key="4" title="تحویل داده شده">
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <Orders setOnOrder={setOnOrder} status='4' />
                                </CardBody>
                            </Card>
                        </Tab>
                        <Tab key="5" title="لغو شده">
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <Orders setOnOrder={setOnOrder} status='5' />
                                </CardBody>
                            </Card>
                        </Tab>
                    </Tabs>}
            </div>
        </>
    );
};

export default OrdersTab;